import { render, staticRenderFns } from "./teamShow.vue?vue&type=template&id=603460c6&scoped=true&"
import script from "./teamShow.vue?vue&type=script&lang=js&"
export * from "./teamShow.vue?vue&type=script&lang=js&"
import style0 from "./teamShow.vue?vue&type=style&index=0&id=603460c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603460c6",
  null
  
)

export default component.exports